import 'bootstrap';




// WEBPACK FOOTER //
// ../.tmp/app.js